// management-frontend/src/App.js
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import { AuthProvider, useAuth } from "./context/AuthContext";

import Login from "./components/Login";
import Logout from "./components/Logout";
import Dashboard from "./components/Dashboard";
import Customer from "./components/Customer";
import CustomerSystem from "./components/CustomerSystem";
import ChangePassword from "./components/ChangePassword";

// Proteção de Rotas - Verifica se o usuário está autenticado
const PrivateRoute = ({ children, requiredRoles, admin }) => {
  const { user, loading } = useAuth(); // Pegando `user`, `roles` e `loading` do contexto

  // Exibe tela de carregamento enquanto os dados estão sendo processados
  if (loading) {
    return <div>Carregando...</div>;
  }

  // Se não houver usuário, redireciona para login
  if (!user) return <Navigate to="/Login" />;

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Logout" element={<Logout />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/Dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/Customers"
            element={
              <PrivateRoute>
                <Customer />
              </PrivateRoute>
            }
          />
          <Route
            path="/CustomerSystem"
            element={
              <PrivateRoute>
                <CustomerSystem />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
